import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IOrganisationTaskTypeFilter } from '../interfaces/organisation-task-type-filter';
import { IOrganisationTaskTypes } from '../interfaces/organisation-task-types';
import { EditService } from './edit.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class OrganisationTaskTypesService extends EditService<
  IOrganisationTaskTypes,
  IOrganisationTaskTypeFilter
> {
  protected entityTitle = 'Organisation Task Types';
  protected url = 'api/organisation-task-types';

  constructor(
    http: HttpClient,
    handlersFactory: HttpResponsesHandlersFactory,
    private authService: AuthService,
  ) {
    super(http, handlersFactory);
  }

  getAllowedTaskTypes(): Promise<number[]> {
    return this.handleRequest(
      this.http.get<number[]>(`${this.url}/allowed`),
      this.handlersFactory.getDefault(),
    );
  }

  saveItems(items: IOrganisationTaskTypes[]) {
    return this.handleRequest(
      this.http.post(`${this.url}/save-items`, items),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  validateTaskTypes(items: IOrganisationTaskTypes[]): Promise<IOrganisationTaskTypes[]> {
    return this.handleRequest(
      this.http.post<IOrganisationTaskTypes[]>(`${this.url}/validate-task-types`, items),
      this.handlersFactory.getDefault(),
    );
  }
}
